export const TEXT_INPUT_TYPE = 'text';
export const PASSWORD_INPUT_TYPE = 'password';
export const LOCK_ICON = 'lock';
export const VISIBILITY_ICON = 'visibility';
export const VISIBILITY_OFF_ICON = 'visibility_off';
export const OLD_PSWD_VISIBILITY = false;
export const OLD_PASSWORD_LABEL = $localize`Existing Password`;
export const NEW_PSWD_VISIBILITY = false;
export const NEW_PASSWORD_LABEL = $localize`New Password`;
export const CONFIRM_PSWD_VISIBILITY = false;
export const CONFIRM_PASSWORD_LABEL = $localize`Confirm New Password`;
export const BUTTON_CANCEL = $localize`Cancel`;
export const ARIAL_LABEL = 'sample arial label';
export const BTN_MAT = 'mat-button';
export const BTN_STYLE_TEXT = 'btn-text';
export const BUTTON_SAVE = $localize`Save Changes`;
export const BUTTON_SUBMIT = $localize`Reset Password`;
export const BTN_MAT_FLAT = 'mat-flat-button';
export const BTN_STYLE_FILLED_SMALL = 'btn-filled-small';
export const BTN_STYLE_FILLED_SMALL_DISABLED = 'btn-filled-small-disabled';
export const BTN_STYLE_FILLED_LARGE = 'btn-filled-large';
export const BTN_STYLE_FILLED_LARGE_DISABLED = 'btn-filled-large-diabled';
